import { GetFormaGiuridicaQuery } from '../../_graphql/generated';

export type FormaGiuridicaState = {
  loading: boolean;
  lista: GetFormaGiuridicaQuery['anagrafica_forma_giuridica'];
  failure: any;
};

export const initialFormaGiuridicaState: FormaGiuridicaState = {
  loading: false,
  lista: [],
  failure: '',
};
